<!-- 分期商城 -->
<template>
  <div class='mall pad-side20'>

<!--    <div class="video-wrap">-->
<!--      <div class="video-poster flex flex-column align-items-center justify-content-center">-->
<!--        <h3>新品</h3>-->
<!--        <p>你值得拥有，快来选购吧</p>-->
<!--        <img src="@/assets/imgs/icon/play.png" alt="">-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="announcement">-->
<!--      <h3 class="title">今日公告</h3>-->
<!--      <div class="box flex align-items-center">-->
<!--        <img src="@/assets/imgs/other/announcement.png" alt="">-->
<!--        <div class="ellips2">习近平总书记走到直播平台前，习近说：“电商，在农副产品的推销方面是非常重要的...</div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <h3 class="title">限时特惠</h3>-->
<!--    <div class="merchandise flex justify-content-between align-items-center" v-for="(item, index) in 3" :key="index">-->
<!--      <div>-->
<!--        <p class="font15">一开倾听</p>-->
<!--        <p class="font20">50%折扣</p>-->
<!--      </div>-->
<!--      <img src="@/assets/imgs/other/announcement.png" alt="">-->
<!--    </div>-->

    <img src="@/assets/imgs/other/icon_activity2020.jpeg" alt="">
    <div class="btn-wrap flex align-items-center justify-content-center">
      <input type="button" value="商城特惠" class="lg-btn" @click="goLoad">
    </div>
    <img src="@/assets/imgs/icon/chart.png" alt="" class="chart-icon" @click="navigateToTalk">
  </div>
</template>

<script>
export default {
  name: 'Mall',

  components: {},

  data () {
    return {
    };
  },

  computed: {},

  created() {},

  methods: {
    navigateToTalk() {
      this.$router.push('/talk')
    },
    goLoad() {
      location.href='http://a.app.qq.com/o/simple.jsp?pkgname=com.jmx.fapp'
    }
  },
}

</script>

<style lang='less' scoped>
  .chart-icon{
    width: 40px;
    height: 40px;
    position: fixed;
    top: 50%;
    right: 20px;
  }
  .mall {
    padding-top: 10px;
    padding-bottom: 97px;
  }
  .video-wrap {
    height: 202px;
    border-radius: 12px;
    background-color: #000;
    .video-poster {
      color: #fff;
      width: 100%;
      height: 100%;
      h3 {
        font-size: 18px;
        padding-bottom: 10px;
      }
      img {
        width: 28px;
        margin-top: 15px;
      }
    }
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    padding: 30px 0 20px;
  }
  .announcement {
    font-size: 12px;
    line-height: 24px;
    .box {
      background:rgba(255,255,255,1);
      box-shadow:0px 8px 15px rgba(231,234,240,1);
      border-radius:12px;
      padding: 12px 10px 11px;
    }
    img {
      width: 56px;
      margin-right: 20px;
    }
  }
  .merchandise {
    height:114px;
    background:rgba(216,216,216,1);
    border-radius: 16px;
    overflow: hidden;
    padding: 0 21px;
    margin-bottom: 20px;
    img {
      width: 98px;
    }
    .font20 {
      margin-top: 18px;
    }
  }
  .btn-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px 0 33px;
    background-color: #fff;
  }
</style>